document.addEventListener('DOMContentLoaded', function () {

  // ---------------- COUNTDOWN (password page) ----------------
  var countdownEl = document.getElementById('countdown');
  if (countdownEl) {
    var launchAttr = countdownEl.getAttribute('data-launch');
    var launchTarget = launchAttr ? new Date(launchAttr).getTime() : null;
    if (launchTarget) {
      var tick = function () {
        var now = new Date().getTime();
        var diff = Math.max(0, launchTarget - now);
        var days = Math.floor(diff / 86400000);
        var hours = Math.floor((diff % 86400000) / 3600000);
        var mins = Math.floor((diff % 3600000) / 60000);
        var secs = Math.floor((diff % 60000) / 1000);
        document.getElementById('cd-days').textContent = String(days).padStart(2, '0');
        document.getElementById('cd-hours').textContent = String(hours).padStart(2, '0');
        document.getElementById('cd-mins').textContent = String(mins).padStart(2, '0');
        document.getElementById('cd-secs').textContent = String(secs).padStart(2, '0');
      };
      tick();
      setInterval(tick, 1000);
    }
  }

  // ---------------- TOAST ----------------
  var toastTimeout;
  function showToast(msg) {
    var toast = document.getElementById('toast');
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toastTimeout);
    toastTimeout = setTimeout(function () { toast.classList.remove('show'); }, 2500);
  }

  // ---------------- CART DRAWER ----------------
  var overlay = document.getElementById('cart-overlay');
  var drawer = document.getElementById('cart-drawer');

  function openCart() {
    if (!overlay || !drawer) return;
    overlay.classList.remove('hidden');
    drawer.classList.remove('hidden');
    refreshCart();
  }
  function closeCart() {
    if (!overlay || !drawer) return;
    overlay.classList.add('hidden');
    drawer.classList.add('hidden');
  }

  document.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
    btn.addEventListener('click', openCart);
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
    btn.addEventListener('click', closeCart);
  });

  function moneyFormat(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function refreshCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  function renderCart(cart) {
    var countEl = document.getElementById('cart-count');
    var itemsEl = document.getElementById('cart-items');
    var subtotalEl = document.getElementById('cart-subtotal');
    if (countEl) countEl.textContent = cart.item_count;
    if (subtotalEl) subtotalEl.textContent = moneyFormat(cart.total_price);
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="cart-empty">Your cart is empty.</div>';
      return;
    }

    itemsEl.innerHTML = cart.items.map(function (item, i) {
      var img = item.image ? '<img src="' + item.image + '" alt="">' : '';
      return (
        '<div class="cart-line">' +
          '<div class="thumb">' + img + '</div>' +
          '<div class="info">' +
            '<div class="name">' + item.product_title + '</div>' +
            '<div class="meta">' + item.variant_title + ' &middot; Qty ' + item.quantity + ' &middot; ' + moneyFormat(item.final_line_price) + '</div>' +
            '<button class="remove" data-remove-line="' + item.key + '">Remove</button>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    itemsEl.querySelectorAll('[data-remove-line]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: btn.getAttribute('data-remove-line'), quantity: 0 })
        })
        .then(function (r) { return r.json(); })
        .then(renderCart);
      });
    });
  }

  refreshCart();

  // ---------------- ADD TO CART (product form) ----------------
  var productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(productForm);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
      .then(function (r) {
        if (!r.ok) throw new Error('add-to-cart-failed');
        return r.json();
      })
      .then(function (item) {
        showToast(item.product_title + ' added to cart.');
        refreshCart();
        openCart();
      })
      .catch(function () {
        showToast('Please select an available option.');
      });
    });
  }

  // ---------------- VARIANT PICKER (product page) ----------------
  var productPage = document.getElementById('product-page');
  if (productPage) {
    var product;
    try {
      product = JSON.parse(productPage.getAttribute('data-product-json'));
    } catch (err) {
      product = null;
    }

    if (product) {
      var selections = {}; // optionIndex -> value
      var priceEl = document.getElementById('pd-price');
      var variantIdInput = document.getElementById('pd-variant-id');
      var addBtn = document.getElementById('pd-add-btn');
      var notifyBox = document.getElementById('pd-notify-box');

      function findMatchingVariant() {
        var keys = Object.keys(selections);
        return product.variants.find(function (v) {
          return keys.every(function (idx) {
            return v.options[idx] === selections[idx];
          });
        });
      }

      function updateUI() {
        var variant = findMatchingVariant();
        var allOptionsChosen = Object.keys(selections).length === (product.options ? product.options.length : 0);

        if (variant) {
          if (priceEl) priceEl.textContent = moneyFormat(variant.price);
          if (variantIdInput) variantIdInput.value = variant.id;
          if (variant.available) {
            addBtn.disabled = false;
            addBtn.textContent = 'Add to Cart';
            notifyBox.classList.add('hidden');
          } else {
            addBtn.disabled = true;
            addBtn.textContent = 'Sold Out';
            if (allOptionsChosen) notifyBox.classList.remove('hidden');
          }
        } else {
          addBtn.disabled = true;
          addBtn.textContent = 'Select an option';
          notifyBox.classList.add('hidden');
        }
      }

      document.querySelectorAll('.variant-options').forEach(function (group) {
        var optionIndex = group.getAttribute('data-option-index');
        group.querySelectorAll('.opt').forEach(function (opt) {
          opt.addEventListener('click', function () {
            if (opt.classList.contains('disabled')) return;
            group.querySelectorAll('.opt').forEach(function (o) { o.classList.remove('selected'); });
            opt.classList.add('selected');
            selections[optionIndex] = opt.getAttribute('data-value');
            updateUI();
          });
        });
      });

      // Preselect first available variant's options, if one exists
      var firstAvailable = product.variants.find(function (v) { return v.available; }) || product.variants[0];
      if (firstAvailable) {
        firstAvailable.options.forEach(function (val, idx) {
          selections[idx] = val;
          var group = document.querySelector('.variant-options[data-option-index="' + idx + '"]');
          if (group) {
            var match = Array.from(group.querySelectorAll('.opt')).find(function (o) { return o.getAttribute('data-value') === val; });
            if (match) match.classList.add('selected');
          }
        });
      }
      updateUI();
    }
  }

  // ---------------- GALLERY THUMBS ----------------
  document.querySelectorAll('.thumb-item').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var full = thumb.getAttribute('data-full');
      var mainImg = document.getElementById('gallery-main-img');
      if (full && mainImg) mainImg.src = full;
    });
  });

  // ---------------- ACCORDION ----------------
  document.querySelectorAll('[data-accordion-toggle]').forEach(function (header) {
    header.addEventListener('click', function () {
      var item = header.parentElement;
      item.classList.toggle('open');
      var symbol = header.querySelector('span');
      if (symbol) symbol.textContent = item.classList.contains('open') ? '\u2212' : '+';
    });
  });

});
